import { render } from "./CorrectionEditorTreatment.vue?vue&type=template&id=8af74a86&ts=true"
import script from "./CorrectionEditorTreatment.vue?vue&type=script&lang=ts"
export * from "./CorrectionEditorTreatment.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__